import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const SixPackContentContainer = styled.div<{
  variation: 'square-first' | 'tall-first';
}>`
  .six-pack-wrapper {
    & > *:not(:last-child) {
      margin-bottom: ${toRem(16)};
    }

    @media${baseVariables.mediaQuery.md} {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: ${toRem(24)};
      grid-auto-flow: dense;
      & > *:not(:last-child) {
        margin-bottom: 0;
      }
    }
    @media${baseVariables.mediaQuery.lg} {
      grid-template-columns: repeat(3, 1fr);
      & > *:nth-child(even) {
        grid-row: ${({ variation }) => (variation === 'square-first' ? 'span 3' : 'span 2')};
      }
      & > *:nth-child(odd) {
        grid-row: ${({ variation }) => (variation === 'square-first' ? 'span 2' : 'span 3')};
      }
      & > *:not(:last-child) {
        margin-bottom: 0;
      }
      & > div:nth-child(3n + 1) {
        grid-column: 1;
      }
      & > div:nth-child(3n + 2) {
        grid-column: 2;
      }
      & > div:nth-child(3n + 3) {
        grid-column: 3;
      }
    }
    .aem-Grid::before,
    .aem-Grid::after {
      display: none;
    }
  }
`;
